import { AnimatedHeadline, Reveal } from "./Reveal";

export default function PageHero({ eyebrow, title, accent, subtitle }) {
  return (
    <section data-testid="page-hero" className="relative overflow-hidden bg-ink text-white">
      <div className="mx-auto max-w-[1440px] px-6 pt-44 pb-24 md:px-12 md:pt-56 md:pb-32">
        {eyebrow && <p className="text-[11px] uppercase tracking-label text-champagne">{eyebrow}</p>}
        <Reveal>
          <h1 className="mt-8 font-serif text-5xl leading-[1.02] tracking-tight md:text-7xl">
            {title} {accent && <span className="italic text-champagne">{accent}</span>}
          </h1>
        </Reveal>
        {subtitle && <Reveal delay={0.1}><p className="mt-8 max-w-2xl text-lg leading-relaxed text-white/75">{subtitle}</p></Reveal>}
      </div>
    </section>
  );
}
